var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#DBEBFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 44.3906C23.1384 43.1936 20.9255 41.2718 19.3743 38.8537C17.8232 36.4356 16.9991 33.6229 17 30.75H47C47.0009 33.6229 46.1768 36.4356 44.6257 38.8537C43.0745 41.2718 40.8616 43.1936 38.25 44.3906V45.75C38.25 46.0815 38.1183 46.3995 37.8839 46.6339C37.6495 46.8683 37.3315 47 37 47H27C26.6685 47 26.3505 46.8683 26.1161 46.6339C25.8817 46.3995 25.75 46.0815 25.75 45.75V44.3906Z",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 25.75C38.25 25.75 35.4375 24.875 38.25 21.375C41.0625 17.875 38.25 17 38.25 17",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 25.75C32 25.75 29.1875 24.875 32 21.375C34.8125 17.875 32 17 32 17",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 25.75C25.75 25.75 22.9375 24.875 25.75 21.375C28.5625 17.875 25.75 17 25.75 17",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.2e1d5a53a432bf20eda1fd316b022c74.svg";
export { ForwardRef as ReactComponent };